import styled from 'styled-components';

const Label = styled.label`
    width: calc(100% - 40px);
`

export default Label;